import React, {useEffect, useState} from 'react';
import {useNavigate, useSearchParams} from "react-router-dom";
import axios from "axios";
import {ApiName, ApiNameGrant} from "../APIname";
import {toast} from "react-toastify";
import Navbar from "./navbar";
import Loading from "./loading";
import bg from "../img/404error1.svg";


function Auth(props) {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [message, setMessage] = useState('');
    const [sucsessText, setSucsessText] = useState(false);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getEmploee()
    }, []);

    function getEmploee() {
        setLoading(true)

        axios.get(`${window.location.pathname==="/auth_student"? ApiNameGrant : ApiName}/api/auth/login`, {
            headers: {
             "ngrok-skip-browser-warning": "true",
            },
            params: {
                code: searchParams.get('code'),
                state: searchParams.get('state')
            }
        }).then((response) => {
            console.log(response)
             if (response.data.isSuccess === true) {
                 setSucsessText(true)
                 setLoading(false)
                localStorage.setItem("myCat", JSON.stringify(response.data.data));
                if (response.data?.data?.currentRole === 'ROLE_OPERATOR') {
                    navigate("/operator/TypeService")
                }
                if (response.data?.data?.currentRole === 'ROLE_RECTOR') {
                    navigate("/adminRector/TypeService")
                }
                if (response.data?.data?.currentRole === 'ROLE_ADMIN') {
                    navigate("/adminAll/TypeService")
                }
                if (response.data?.data?.currentRole === 'ROLE_DEPARTMENT') {
                    navigate("/department/TypeService")
                }
                 if (response.data?.data?.currentRole === 'ROLE_STUDENT') {
                     localStorage.setItem("myCat", JSON.stringify(response.data.data.accessToken));
                     navigate("/profile")
                 }
            }
            else {
                setLoading(false)
                setMessage(response.data.message)
            }
        }).catch((error) => {
            console.log(error);
            setLoading(false)
            setMessage(error?.response?.data?.message)

        })
    }

    useEffect(() => {
        setMessage('')
        notify();
    }, [message,]);

    function notify() {
        if (message !== '') {
            toast.error(message)
        }
    }

    return (
        <>
            {loading === true ? <Loading/> : <div className="home">
                <div className="container">
                    <div className="row d-flex align-items-center justify-content-center">
                        <Navbar/>

                        <img className='w-50' src={bg} alt='gif'/>
                    </div>

                </div>
            </div>}

        </>
    );
}

export default Auth;